import script from "./index - 副本.vue?vue&type=script&setup=true&lang=js"
export * from "./index - 副本.vue?vue&type=script&setup=true&lang=js"

import "./index - 副本.vue?vue&type=style&index=0&id=04e6f113&lang=less"

const __exports__ = script;

export default __exports__